import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import * as Models from '@shared/core/models';

@Component({
    template: '<div>This component requires extending</div>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionTypeToggleTypesComponent {
    @Input() public inverted: boolean = true;
    @Input() public items!: Array<Models.CollectionTypeItem>;
    @Input() public selected!: Models.CollectionTypeItem;
    @Input() public trackByFn!: (index: number, item: any) => number;
    @Input() public size: OLO.Components.BUTTON_SIZE = null;
    @Input() public feel: OLO.Components.BUTTON_FEEL | OLO.Components.BUTTON_CIRCLE_FEEL = 'secondary';

    @Output() public onSelected: EventEmitter<{ $event: Event; item: Models.CollectionTypeItem; }> = new EventEmitter();

    public handleLinkClick($event: Event, item: Models.CollectionTypeItem): void {
        this.onSelected.emit({
            $event,
            item
        });
    }

    public handleDropdownSelected(item: Models.CollectionTypeItem): void {
        this.onSelected.emit({
            $event: null,
            item
        });
    }

    private _defaultTrackerFn(index: number): number {
        return index;
    }

    public get trackerFn() {
        return this.trackByFn || this._defaultTrackerFn;
    }
}
